module.exports = __webpack_public_path__ + "img/ico-7-active.a966471f.svg";